define('view/module/review/ReviewFormModuleView',['require','view/controller/review/ReviewFormView'],function (require) {

    var ReviewFormView = require('view/controller/review/ReviewFormView');

    /**
     * Reviews module form view
     *
     * @class ReviewFormModuleView
     */
    return ReviewFormView.extend({

        template: '#reviews_form_module_view',

        onDomRefresh: function () {
            Backbone.Wreqr.radio.vent.trigger('module', 'shown', {
                'module': 'review_form'
            });
        }

    });

});
